export default new class LiveChat {
    constructor() {
        this.liveChat = '_live-chat';
        this.handler();
    }

    handler() {
        $(document).on('click', `.${this.liveChat}`, function () {
            startLiveChatWindow();
        });
    }
}();
